import React, { useMemo, useEffect } from 'react';
import { ThemeProvider } from '@devotel/design-system';
import { useWhiteLabel } from './WhiteLabelProvider';
import { createCustomTheme } from './theme';
import {
  createDynamicThemes,
  applyCssCustomProperties,
  getCurrentThemeMode,
} from './dynamicThemeGenerator';

interface ThemeWrapperProps {
  children: React.ReactNode;
}

const ThemeWrapper: React.FC<ThemeWrapperProps> = ({ children }) => {
  const whiteLabel = useWhiteLabel();

  // Create both light and dark themes based on white label config
  const themes = useMemo(() => createDynamicThemes(whiteLabel), [whiteLabel]);

  // Get current theme based on Redux state
  const currentThemeMode = getCurrentThemeMode();
  const currentTheme = themes[currentThemeMode];

  // Apply CSS custom properties when theme changes
  useEffect(() => {
    applyCssCustomProperties(whiteLabel, currentTheme);
  }, [whiteLabel, currentTheme]);

  // Create theme for design system
  const designSystemTheme = useMemo(
    () => createCustomTheme(whiteLabel),
    [whiteLabel]
  );

  return (
    <ThemeProvider initialTheme={designSystemTheme}>{children}</ThemeProvider>
  );
};

export default ThemeWrapper;
